export default "__VITE_ASSET__cb02f9b0__"